<template>
    <div class="login">
        <div class="logo">
<!--            <img class="botter-logo" src="../assets/logo.png" alt="">-->
        </div>
        <div class="login-shape"></div>
        <v-container fluid>
            <v-layout row wrap class="login-content">
                <v-flex md5>
                    <img src="../assets/img/graphic2.svg" class="login-img" alt="login"/>
                </v-flex>
                <v-flex xs1></v-flex>
                <v-flex md4 class="pa-4 ml-5 login-form">
                    <v-form v-model="valid">
                        <div class="login-desc">
                            <h2 class="headline">Forget Password.</h2>
                        </div>
                        <v-form v-model="valid" ref="form" class="mt-3">
                            <v-text-field
                                    outline
                                    v-model="username"
                                    name="login"
                                    placeholder ="EMail"
                                    type="text"
                                    :rules="[v => !!v || 'Email required']"
                            ></v-text-field>
                            <v-btn @click="forgetPassword" block large round color="primary">Send</v-btn>
                            <v-btn  block large round flat to="/login" color="secondary">Back To Login</v-btn>
                        </v-form>
                        <div v-if="wrongCredentials === true" class="text-xs-center white--text">Invalid Email</div>
                        <div v-if="emailSuccuess === true" class="text-xs-center white--text">Please Check Your Email</div>
                    </v-form>
                </v-flex>
                <v-flex md1></v-flex>
            </v-layout>

        </v-container>
    </div>
</template>

<script>
    export default {
        data: () => ({
            username: '',
            password: '',
            valid: true,
            wrongCredentials: false,
            emailSuccuess: false
        }),
        methods: {
            forgetPassword () {
                if (this.$refs.form.validate()) {
                    const store = this.$store
                    this.$http_noauth.post('/auth/forget', {
                        email: this.username
                    })
                        .then(response => {
                            this.emailSuccuess = true
                        })
                        .catch(error => {
                            this.wrongCredentials = true
                        });
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .login-form{
        .v-form{
            margin-top: 30%;
        }
    }
    body {
        height: 100vh !important;
        overflow: hidden;
    }
</style>
